"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const Grid = (props) => {
    const { gap } = props;
    const columns = typeof props.columns === 'object' ? props.columns : {
        xs: props.columns,
    };
    let gridColClasses = [];
    Object.keys(columns).forEach((viewPort) => {
        const columnCount = columns[viewPort];
        if (viewPort === 'xs') {
            gridColClasses.push(`grid-cols-${columnCount}`);
        }
        else {
            gridColClasses.push(`${viewPort}:grid-cols-${columnCount}`);
        }
    });
    if (props.columns === 'auto') {
        gridColClasses = ['auto-cols-fr', 'grid-flow-col'];
    }
    const className = classnames_1.default(props.className, gridColClasses, helpers_1.resolveCssProp('gap', gap));
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    return react_1.default.createElement("div", Object.assign({}, primitiveProps, { className: className }));
};
exports.default = withJourney_1.default('j-grid', Grid);
